import { CountryCode } from '../../enums/country-code.enum'
import { IStateWithRegionInfo } from '../../interfaces/state.interface'

export interface StatesStateModel {
  states: IStateWithRegionInfo[]
  regions: IStateWithRegionInfo[]
  userCountry: CountryCode
}
